import React from 'react';
import './style.css';

export const NgGameRPGArenaLive = ({ isLeft, arena: { width: arenaWidth }, zIndex }) => {

    if (isLeft) {
        return <div className='ngg_arena_lives_container ngg_arena_lives_container_left' style={{ top: 0, zIndex, width: arenaWidth * 0.2, height: arenaWidth * 0.02 }}>
            <div className='ngg_arena_lives_container_hp' />
            <div className='ngg_arena_lives_container_hpmin' />
        </div>
    }

    return <div className='ngg_arena_lives_container ngg_arena_lives_container_right' style={{ top: 0, zIndex, left: arenaWidth - arenaWidth * 0.2, width: arenaWidth * 0.2, height: arenaWidth * 0.02 }}>
        <div className='ngg_arena_lives_container_hp' />
        <div className='ngg_arena_lives_container_hpmin' />
    </div>
}